import React from "react";
import property from "../property.json";

function Experience() {
  return (
    <div className="about">
      <h3 className="title2">Professional Experience:</h3>
      {property.organization.map((organization, index1) => {
        return (
          <div className="box">
            <div className="year_company">
              <h4>
                {organization.name}</h4>
            </div>
            
          <span className="nobold">{organization.description}</span><br />
                        
                      
            <div className="text">
              <h4>{organization.designation}</h4>
              
              {organization.project.map((project) => {
                return (
                  <p>
                    {project.name && <b>{project.name}</b>}
                    <ul>
                      {project.responsibility.map((responsibility) => {
                        return (
                          <li>{responsibility.projectName && <b>{responsibility.projectName}:</b>} {responsibility.value}</li>
                        )
                      })}
                    </ul>
                    <br />
                  </p>
                  
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Experience;
